<template>
  <div>
    <div class="student-list" v-if="showType == 'list'">
      <!--列表形式-->
      <ul class="student-ul" v-if="studentListCard.length > 0">
        <li :class="classObject(item.offLineStatus, item.handleStatus, 'list')"  v-for="(item, index) in sortStudentData(studentListCard)" @click="viewStudent(item, index)" :key="'list_' + index">
          <div class="student-item">
            <div class="left-image" v-if="getAlarmNum(item) > 0">
              <!-- <div class="left-image"> -->
              <el-popover
                @hide="showAlarm(item.user_id)"
                placement="right-start"
                :width="language == 'zh' ? 790 : 890"
                popper-class="student-alarm-popper"
                trigger="hover">
                <div class="student-alarm-list" >
                  <ul class="student-alarm-ul">
                    <li class="first-alarm-item" v-for="(messageItem, messageIndex) in filterMessageList(messageList, item.user_id)"  :key="'history_' + messageIndex ">
                      <AlarmItem
                        :messageItem="messageItem"
                        :item="item"
                        :showType="'list'"
                      />
                    </li>
                  </ul>
                </div>
                <div class="photo" slot="reference" :style="{background: item.offLineStatus ? '#a7b2d2' : colors[index%8]}">
                  <span class="name" v-if="item.real_name">{{item.real_name.slice(0, 2)}}</span>
                  <span class="name" v-else-if="item.nick">{{item.nick.slice(0, 2)}}</span>
                  <div class="alarm-module" v-if="getAlarmNum(item) > 0">
                    <span class="alarm-num">{{getAlarmNum(item)}}</span>
                  </div>
                </div>
              </el-popover>
            </div>
            <div class="left-image" v-else>
              <div class="photo" :style="{background: item.offLineStatus ? '#a7b2d2' : colors[index%8]}">
                <span class="name" v-if="item.real_name">{{item.real_name.slice(0, 2)}}</span>
                <span class="name" v-else-if="item.nick">{{item.nick.slice(0, 2)}}</span>
                <!-- <div class="alarm-module" v-if="item.msgNum > 0">
                  <span class="alarm-num">{{item.msgNum}}</span>
                </div> -->
              </div>
            </div>
            <div class="right-detail">
              <div class="user-info">
                <span class="user-name" v-if="item.real_name">{{item.real_name}}</span>
                <span class="user-name" v-else-if="item.nick">{{item.nick}}</span>
                <span>{{item.data[0].course_sname}}</span>
                <span>{{item.data[0].section_sname}}</span>
                <span>{{item.data[0].topic_sname}}</span>
              </div>
              <ul class="detail-info-ul">
                <li>
                  <div class="first-line">
                    <i class="iconfont iconanswer" v-if="!item.offLineStatus && item.data[0].event.indexOf('ANSWER') > -1"></i>
                    <i class="iconfont iconvideo" v-if="!item.offLineStatus && item.data[0].event.indexOf('VIDEO') > -1"></i>
                    <span class="emphasize" v-if="!item.offLineStatus">{{item.data[0] | getEventName(item.data[0].video_type || '')}}</span>
                    <span class="emphasize" v-else-if="item.offLineStatus">{{ $t('studentList.list.263629-0') }}</span>
                  </div>
                  <div class="second-line">
                    <span>{{ $t('studentList.list.263629-1') }}</span>
                    <span>{{current - item.data[0].server_time | parseUserSpentTime}}</span>
                  </div>
                  <div class="third-line">
                    <span class="knowledge-label">{{ $t('studentList.list.263629-2') }}</span>
                    <span class="current-knowdlege-name" v-if="item.data[0].tag_sname">{{item.data[0].tag_sname}}</span>
                    <span class="current-knowdlege-name" v-else>--</span>
                  </div>
                </li>
                <li>
                  <div class="first-line">
                    <span class="emphasize" v-if="item.data[0].module_sname">【{{item.data[0].module_sname}}】</span>
                    <span v-else>--</span>
                    <!-- <span class="module_sname_label" v-if="item.data[0].module_sname">模块</span> -->
                  </div>
                  <div class="second-line">
                    <span>{{ $t('studentList.list.263629-3') }}</span>
                    <span v-if="item.module_answer" :class="[item.module_answer.rate < 50 ? 'red-num' : '']">{{item.module_answer.rate}}%</span>
                    <span v-else>--</span>
                  </div>
                  <div class="third-line">
                    <span>{{ $t('studentList.list.263629-4') }}</span>
                    <span v-if="item.module_learn">{{item.module_learn.total_length | formatTime}}</span>
                    <span v-else>--</span>
                  </div>
                </li>
                <li class="count">
                  <div class="today-data">
                    <div class="first-line">
                      <span v-if="item.today_course_answer" :class="[item.today_course_answer.rate < 50 ? 'num red-num' : 'num']">{{item.today_course_answer.rate}}%</span>
                      <span v-else class="num">--</span>
                      <span class="small-num" v-if="item.today_course_answer">({{item.today_course_answer.right_total}}/{{item.today_course_answer.total}})</span>
                    </div>
                    <p class="rate-num">{{ $t('studentList.list.263629-5') }}</p>
                  </div>
                </li>
                <li class="count">
                  <div class="today-data">
                    <div class="first-line" v-if="item.learning_version != 1">
                      <span v-if="item.today_course_knowledge && item.today_course_knowledge.rate" :class="[item.today_course_knowledge.rate < 70 ? 'num red-num' : 'num']">{{item.today_course_knowledge.rate}}%</span>
                      <span v-else class="num">--</span>
                    </div>
                    <div class="first-line" v-else>--</div>
                    <p class="rate-num">{{ $t('studentList.list.263629-6') }}</p>
                  </div>
                </li>
                <li class="count">
                  <div class="today-data">
                    <div class="first-line">
                      <span class="num" v-if="item.today_course_learn">{{item.today_course_learn.total_length | formatTime}}</span>
                      <span class="num" v-else>--</span>
                    </div>
                    <p class="rate-num">{{ $t('studentList.list.263629-7') }}</p>
                  </div>
                </li>
<!--                <li class="is-jieru" v-if="item.isJieru == 1">-->
<!--                  <i class="icon-jieru"></i>-->
<!--                </li>-->
                <li class="option" v-if="!item.offLineStatus">
                  <el-dropdown trigger="click">
                    <span class="c-more-btn" @click.stop><i class="iconfont icondots"></i></span>
                    <el-dropdown-menu slot="dropdown" v-if="item.handleStatus == 2">
                      <el-dropdown-item command="a">
                        <span  style="display: block;width: 68px; text-align: center" @click="handleStudent(item, index, 3)">{{ $t('studentList.list.263629-8') }}</span>
                      </el-dropdown-item>
                      <el-dropdown-item command="b">
                        <span  style="display:block;width: 68px; text-align: center" @click="handleStudent(item, index, 1)">{{ $t('studentList.list.263629-9') }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                    <el-dropdown-menu slot="dropdown" v-else-if="item.handleStatus == 3">
                      <el-dropdown-item command="a">
                        <span  style="display: block;width: 68px; text-align: center" @click="handleStudent(item, index, 2)">{{ $t('studentList.list.263629-10') }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                    <el-dropdown-menu slot="dropdown" v-else-if="item.handleStatus == 1">
                      <el-dropdown-item command="a">
                        <span  style="display: block;width: 68px; text-align: center" @click="handleStudent(item, index, 2)">{{ $t('studentList.list.263629-11') }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </li>
                <li class="option" v-else>
                  <el-dropdown trigger="click">
                    <span class="c-more-btn" @click.stop><i class="iconfont icondots"></i></span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="a">
                        <span  style="display: block;width: 68px;text-align: center" @click="closeCard(item, index)">{{ $t('studentList.list.263629-12') }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </li>
              </ul>
              <!-- <ul class="history-ul">
                <li v-for="(messageItem, index) in filterMessageList(messageList, item.user_id)" v-if="index < 5 && messageItem.user_id == item.user_id" :key="'history_' + index ">
                  <span class="history-item">{{messageItem.event | getEventName}}</span>
                </li>
              </ul> -->
              <!-- <div class="now-jieru" v-if="item.isJieru == 1">
                <i class="icon-jieru"></i>
              </div> -->
            </div>
          </div>
<!--          <div class="has-zgt" v-if="item.data[0].is_correct">-->
<!--            <i class="icon-zgt"></i>-->
<!--          </div>-->
          <div class="has-zgt" v-if="item.data[0].correct_notify > 0">
            <i class="icon-zgtpg"></i>
          </div>
        </li>
      </ul>
      <div class="no-people" v-else>
        <i class="icon-shafa"></i>
        <p class="text">{{isAgent ? `${$t('studentList.list.263629-13')}` : `${$t('studentList.list.263629-14')}`}}</p>
      </div>
    </div>

    <!--卡片形式-->
    <div v-else-if="showType == 'card'">
      <div class="card-list">
        <ul class="card-ul">
          <li class="card-item" v-for="(item, index) in studentListCard" :key="index" @click="viewStudent(item, index)">
            <div class="user-info">
              <div class="left-image">
                <div class="photo-image">
                  <span class="name">{{item.real_name.slice(0, 2)}}</span>
                </div>
              </div>
              <div class="user-course">
                <p class="user-name">{{item.real_name}}</p>
                <div class="course-detail">
                  <span>{{item.data[0].course_sname}}</span>
                  <span>{{item.data[0].section_sname}}</span>
                  <span>{{item.data[0].topic_sname}}</span>
                </div>
              </div>
            </div>
            <div class="handle-wrap">
              <div class="handle-item first">
                <div>
                  <span class="current">{{item.data[0] | getEventName}}</span>
                </div>
                <div class="bottom-tips">
                  <span>{{ $t('studentList.list.263629-1') }}</span>
                  <span>15:20</span>
                </div>
              </div>
              <div class="handle-item second">
                <p class="rate" v-if="item.data[0].today_course_answer">{{item.data[0].today_course_answer.rate}}%</p>
                <p class="rate" v-else>--</p>
                <p class="bottom-tips">{{ $t('studentList.list.263629-5') }}</p>
              </div>
              <div class="handle-item third">
                <p class="rate" v-if="item.data[0].today_course_knowledge">{{item.data[0].today_course_knowledge.rate}}%</p>
                <p class="rate" v-else>--</p>
                <p class="bottom-tips">{{ $t('studentList.list.263629-15') }}</p>
              </div>
            </div>
            <div class="current-module">
              <span class="module-name">【{{item.data[0].module_sname}}】</span>
              <span class="knowledge-text">{{item.data[0].tag_sname}}</span>
            </div>
            <ul class="history-ul">
              <li v-for="(item, index) in messageList" v-if="index < 3" :key="'history_' + index ">
                <span class="history-item">{{item.event | getEventName}}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!--/.卡片形式-->

    <!--左侧列表形式-->
    <div class="left-list" v-else-if="showType == 'leftList'">
      <div class="module-header-title sub" >
        <span class="color-block 1111"></span>
        <template v-if="!isAgent">
          <span v-if="!isCloseLeft && typeof(nowOnlineStudent.count) != 'undefined'">{{ $t('studentList.list.263629-16') }}{{nowOnlineStudent.count}}{{ $t('studentList.list.263629-17') }}</span>
          <span v-else-if="isCloseLeft && typeof(nowOnlineStudent.count) != 'undefined'">{{ $t('studentList.list.263629-18') }}{{nowOnlineStudent.count}}{{ $t('studentList.list.263629-17') }}</span>
        </template>
        <template v-else>
          <span v-if="!isCloseLeft && typeof(nowOnlineStudent.count) != 'undefined'">{{ $t('studentList.list.263629-19') }}{{nowOnlineStudent.count}}{{ $t('studentList.list.263629-17') }}</span>
        </template>
      </div>
      <el-scrollbar style="height:100%; background: #fff">
        <ul class="student-list">
          <li :class="[item.user_id == currentUserId ? 'single-item active' : 'single-item', item.is_not_follow == 1 ? 'not-follow' : '']"  v-for="(item, index) in sortStudentData(studentListCard)" :key="`left_list_${index}`" @click="viewStudent(item, index, 'left')">
            <div :class="classObject(item.offLineStatus, item.handleStatus, 'left')">
              <div class="left-side" v-if="getAlarmNum(item) > 0">
                <!-- <div class="left-side"> -->
                <el-popover
                  @hide="showAlarm(item.user_id)"
                  placement="right-start"
                  :width="language == 'zh' ? 790 : 890"
                  popper-class="student-alarm-popper"
                  trigger="hover">
                  <div class="student-alarm-list" >
                    <ul class="student-alarm-ul">
                      <li class="first-alarm-item" v-for="(messageItem, messageIndex) in filterMessageList(messageList, item.user_id)" v-if="messageItem.user_id == item.user_id"
                        :key="'history_' + messageIndex ">
                        <AlarmItem
                          :messageItem="messageItem"
                          :item="item"
                          :showType="'list'"
                        />
                      </li>
                    </ul>
                  </div>
                  <div class="photo-content" slot="reference" :style="{background: item.offLineStatus ? '#a7b2d2' : colors[index%8]}">
                    <span class="name" v-if="item.real_name">{{item.real_name.slice(0, 2)}}</span>
                    <span class="name" v-else-if="item.nick">{{item.nick.slice(0, 2)}}</span>
                    <div class="alarm-module" v-if="getAlarmNum(item) > 0">
                      <span class="alarm-num">{{getAlarmNum(item)}}</span>
                    </div>
                  </div>
                </el-popover>
              </div>
              <div class="left-side" v-else>
                <div class="photo-content" :style="{background: item.offLineStatus ? '#a7b2d2' : colors[index%8]}">
                  <span class="name" v-if="item.real_name">{{item.real_name.slice(0, 2)}}</span>
                  <span class="name" v-else-if="item.nick">{{item.nick.slice(0, 2)}}</span>
                </div>
              </div>
              <div class="right-side" v-if="!isCloseLeft">
                <div class="user-name-x">
                  <div class="left-user-name">
                    <span v-if="item.real_name" class="student-name">{{item.real_name}}</span>
                    <span v-else-if="item.nick" class="student-name">{{item.nick}}</span>
                    <span class="current-option" v-if="!item.offLineStatus">{{item.data[0] | getEventName(item.data[0].video_type || '')}}</span>
                    <span class="current-option" v-if="item.offLineStatus">{{ $t('studentList.list.263629-0') }}</span>
                  </div>
                  <span class="wait-correct" v-if="item.data[0].correct_notify > 0">
                    <i class="icon-has-zgt"></i>
                  </span>
                </div>
                <p class="module" v-if="item.data[0].module_sname">【{{item.data[0].module_sname}}】{{item.data[0].tag_sname}}</p>
                <p class="module empty" v-else>--</p>
              </div>
              <div class="right-side" v-else>
                <div class="user-name-x">
                  <div class="left-user-name">
                    <span v-if="item.real_name" class="student-name">{{item.real_name}}</span>
                    <span v-else-if="item.nick" class="student-name">{{item.nick}}</span>
                  </div>
                </div>
              </div>
              <div v-if="!isCloseLeft">
                <div class="handle" v-if="!item.offLineStatus">
                  <el-dropdown trigger="click">
                    <span class="c-more-btn" @click.stop><i class="iconfont icondots"></i></span>
                    <el-dropdown-menu slot="dropdown" v-if="item.handleStatus == 2">
                      <el-dropdown-item command="a">
                        <span  style="display: block;width: 68px;text-align: center" @click="handleStudent(item, index, 3)">{{ $t('studentList.list.263629-8') }}</span>
                      </el-dropdown-item>
                      <el-dropdown-item command="b">
                        <span  style="display:block;" @click="handleStudent(item, index, 1)">{{ $t('studentList.list.263629-9') }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                    <el-dropdown-menu slot="dropdown" v-else-if="item.handleStatus == 3">
                      <el-dropdown-item command="a">
                        <span  style="display: block;width: 68px; text-align: center" @click="handleStudent(item, index, 2)">{{ $t('studentList.list.263629-10') }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                    <el-dropdown-menu slot="dropdown" v-else-if="item.handleStatus == 1">
                      <el-dropdown-item command="a">
                        <span  style="display: block;width: 68px; text-align: center" @click="handleStudent(item, index, 2)">{{ $t('studentList.list.263629-11') }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-else>
                  <el-dropdown trigger="click">
                    <span class="c-more-btn" @click.stop><i class="iconfont icondots"></i></span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="a">
                        <span  style="display: block;width: 68px;text-align: center" @click="closeCard(item, index)">{{ $t('studentList.list.263629-12') }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <!-- <span class="wait-correct" v-if="item.data[0].correct_notify > 0">
              <i class="icon-zgtpg"></i>
            </span> -->
          </li>
        </ul>
      </el-scrollbar>
    </div>
    <!--/.左侧列表形式-->
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import { setColor } from '@/utils';
  import AlarmItem from '@/components/alarmItem';
  import Bus from '@/utils/bus.js';
  import { getAuthUserCount } from '@/api/base';
  export default {
    name: "list",
    data() {
      return {
        currentIndex: '',
        currentStudentItem: {},
        studentList: [],
        cTimer: null,
        current: 0,
        colors: ['#B7A1FF', '#90DF89', '#E2BC00', '#69DAD8', '#79ACFF', '#459CD7', '#5B78D8', '#A780D8'],
        studentCount: 0,
        alarmLimitList: ['WARN_WRONG_ANSWER', 'WARN_ANSWER_HESITATE', 'WARN_VIDEO_END_DAZE', 'WARN_VIDEO_PLAYED_SKIP', 'WARN_VIDEO_UNPLAYED_SKIP', 'WARN_ANSWER_TOO_FAST', 'WARN_ANSWER_TOO_SLOW'],
        onlineStudentCount: '',
        nowOnlineStudent: {},
        isAgent: false, // 是否是代理商
        authUserCount: '', // 授权数量
        language: 'zh',
      }
    },
    props: {
      studentListCard: {
        type: Array,
      },
      messageList: {
        type: Array,
      },
      studentListPan: {
        type: Array
      },
      showType: {
        type: String
      },
    },
    components: { AlarmItem },
    computed: {
      ...mapGetters([
        'currentViewStudent',
        'currentUserId',
        'leftStudentCount',
        'pageStudentCard',
        'isCloseLeft'
      ]),
    },
    watch: {
      messageList: function (newArr, oldArr){
      },
      studentListCard: function(newArr, oldArr) {
        if (newArr.length > 0) {
          if (this.currentViewStudent['user_id'] == '' && this.$route.path == '/supervise/detail') { // 说明存储在store中的当前学生丢失了，重新去查找
            let index = '';
            let selectItem = '';
            let allCount = 0;
            for (let i= 0; i < newArr.length; i++) {
              let student = newArr[i];
              if (sessionStorage.getItem('user_id') == student['user_id']) {
                index = i;
                selectItem = student;
                break;
              }
              allCount++;
            }
            if (index == '' && newArr.length > 0) {
              index = 0;
              selectItem = newArr[0];
            }
            this.viewStudent(selectItem, index, 'left');
            this.onlineStudentCount = allCount;
            this.nowOnlineStudent = {};
            this.nowOnlineStudent['count'] = allCount;
          }
        }
      },
    },
    created() {
      Bus.$on('msg', (e) => {
        this.onlineStudentCount = e.length;
        this.nowOnlineStudent = {};
        this.nowOnlineStudent['count'] = e.length;
      })
      //this.queryAuthUserCount();
      this.language = sessionStorage.getItem('Select-language') || 'zh'
    },
    mounted() {
      this.$nextTick(() => {
        if (!!sessionStorage.getItem('studentList') && this.onlineStudentCount == 0) {
          setTimeout(() => {
            let count = (JSON.parse(sessionStorage.getItem('studentList'))).length
            if (count > 0) {
              this.nowOnlineStudent = {};
              this.nowOnlineStudent['count'] = count;
            }
          }, 2000)
        }
      })
      const vm = this
      if (typeof vm.cTimer !== 'undefined') clearInterval(vm.cTimer)
      vm.cTimer = setInterval(function() {
        vm.current = new Date().getTime()
      }, 5000)

      Bus.$on('viewFirstStudent', (isLeft) => {
        if (this.studentListCard.length > 0) {
          let newStudentArr = this.sortStudentData(this.studentListCard);
          let firstStudent = newStudentArr[0];
          this.$store.commit('SET_CURRENT_USER_ID', firstStudent['user_id']);
          this.viewStudent(firstStudent, 0, isLeft);
        }
      })
      let teacherInfo = JSON.parse(sessionStorage.getItem('TEACHER_INFO'));
      if (teacherInfo.is_agent_school) {
        this.isAgent = teacherInfo.is_agent_school;
      }
    },
    methods: {
      viewStudent (val, index, isLeft) {
        const cardtop = this.studentListCard.filter(card => card.user_id == (typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''))
        if (typeof index !== 'undefined' && cardtop.length > 0) {
          cardtop[0].index = index
        } else {
          cardtop[0].index = typeof val.index !== 'undefined' ? val.index : cardtop[0].index
        }
        this.cardTop = cardtop
        const vm = this
        const user_id = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
        console.log('user_id========='+user_id);
        // debugger
        const st = vm.studentListCard.filter(event_cell => event_cell.user_id == user_id)
        // debugger
        console.log('863', st)
        const qId = (typeof st[0].data[0].question_ids !== 'undefined' && st[0].data[0].question_ids instanceof Array) ? st[0].data[0].question_ids.join(',') : ''
        console.log(qId)
        const topic_id = typeof st[0].data[0].topic_id !== 'undefined' ? st[0].data[0].topic_id : ''
        const subject_id = typeof st[0].data[0].subject_id !== 'undefined' ? st[0].data[0].subject_id : ''
        const school_id = typeof st[0].data[0].school_id !== 'undefined' ? st[0].data[0].school_id : ''
        const flow_id = typeof st[0].data[0].flow_id !== 'undefined' ? st[0].data[0].flow_id : ''
        const exam_else_info = typeof st[0].data[0].exam_else_info !== 'undefined' ? st[0].data[0].exam_else_info : ''
        const jupiter_stage = typeof st[0].data[0].stage !== 'undefined' ? st[0].data[0].stage : ''
        const course_id = typeof st[0].data[0].course_id !== 'undefined' ? st[0].data[0].course_id : ''
        // const learning_version = typeof st[0].data[0].learning_version !== 'undefined' ? st[0].data[0].learning_version : ''
        const module_type = typeof st[0].data[0].module_type !== 'undefined' ? st[0].data[0].module_type : ''
        const module_name = typeof st[0].data[0].module_name !== 'undefined' ? st[0].data[0].module_name : ''
        const lesson_id = typeof st[0].data[0].lesson_id !== 'undefined' ? st[0].data[0].lesson_id : ' '
        const knowledge_code = typeof st[0].data[0].tag_code !== 'undefined' ? st[0].data[0].tag_code : ' '
        const question_bank_version = typeof st[0].data[0].question_bank_version !== 'undefined' ? st[0].data[0].question_bank_version : ''
        const question_vno = typeof st[0].data[0].question_vno !== 'undefined' ? st[0].data[0].question_vno : 0
        const account_id = val.data[0].account_id
        const stage = typeof st[0].data[0].stage !== 'undefined' ? st[0].data[0].stage : ''
        const q_forms = typeof st[0].data[0].q_forms !== 'undefined' ? st[0].data[0].q_forms : ''
        const learning_version = cardtop[0]['course_version'];

        const photoColor = this.colors[typeof (index) !== 'undefined' ? index : 0 % 8];
        let today_course_answer = {};
        let today_course_knowledge = {};
        let today_course_learn = {};
        let module_answer = {};
        let module_learn = {};

        let getQuestionServerTime = '';

        if (st[0].data[0].event == 'GET_QUESTION') {
          getQuestionServerTime = st[0].data[0].server_time;
        }

        if (typeof (cardtop[0].today_course_answer) !='undefined') {
          today_course_answer = cardtop[0].today_course_answer;
        }
        // else {
        //   today_course_answer = this.currentViewStudent['today_course_answer'];
        // }

        if (typeof (cardtop[0].today_course_knowledge) !='undefined') {
          today_course_knowledge = cardtop[0].today_course_knowledge;
        }
        // else {
        //   today_course_knowledge = this.currentViewStudent['today_course_knowledge'];
        // }

        if (typeof (cardtop[0].today_course_learn) !='undefined') {
          today_course_learn = cardtop[0].today_course_learn;
        }
        // else {
        //   today_course_learn = this.currentViewStudent['today_course_learn'];
        // }

        if (typeof (cardtop[0].module_answer) !='undefined') {
          module_answer = cardtop[0].module_answer;
        }
        // else {
        //   module_answer = this.currentViewStudent['module_answer'];
        // }

        if (typeof (cardtop[0].module_learn) !='undefined') {
          module_learn = cardtop[0].module_learn;
        }
        // else {
        //   module_learn = this.currentViewStudent['module_learn'];
        // }

        let eventMessage = '';
        if (st[0].data[0].event) {
          eventMessage = st[0].data[0].event;
        }

        this.$emit('setMessageDisposeStatus', user_id);
        this.$emit('viewStudentDetail', val, index);
        this.$store.commit("SET_CURRENT_VIEW_STUDENT", {
          exam_else_info,
          school_id,
          user_id,
          course_id,
          topic_id,
          lesson_id,
          account_id,
          knowledge_code,
          stage,
          flow_id,
          subject_id,
          jupiter_stage,
          learning_version,
          question_bank_version,
          question_vno,
          photoColor,
          qId,
          msg: '',
          eventMessage,
          module_type,
          module_name,
          today_course_answer,
          today_course_knowledge,
          today_course_learn,
          module_answer,
          module_learn,
          getQuestionServerTime,
          q_forms
        });
        this.$store.commit('SET_CURRENT_USER_ID', user_id);
        if (this.pageStudentCard['msg'] == '') { // 说明缓存里面没有值
          let tempPageStudentCard = {
            val: val,
            index: typeof index !== 'undefined' ? index : -1,
            studentListCard: this.studentListCard,
            msg: 'detail'
          }
          this.$store.commit('SET_PAGE_STUDENT_CARD', tempPageStudentCard)
        }
        if (!isLeft) {
          this.$router.push({ path: '/supervise/detail', query: {} });
        }
      },
      getMessageListLength(item) {
        let filterList = this.messageList.filter((message) => {
          return message.user_id == item.user_id;
        })
        return filterList.length >= 100 ? 99: filterList.length;
      },
      // 置顶/取消置顶 暂时不看他/重新关注ta
      handleStudent (selectItem, selectIndex, status) {
        this.$emit('handleStudent', selectItem, selectIndex, status);
        let currentTime = new Date().getTime();
        if (!!sessionStorage.getItem('studentCardX')) { // 说明之前已经存储过学生列表的顺序了
          let studentCardX = sessionStorage.getItem('studentCardX');
          let studentCardArr = JSON.parse(studentCardX);
          // 判断当前学生是否存储过
          let findIndex =  -1;
          for (let i=0; i < studentCardArr.length; i++ ) {
            let studentCardItem = studentCardArr[i];
            if (studentCardItem['user_id'] == selectItem['user_id']) {
              findIndex = i;
              break;
            }
          }
          if (findIndex == -1) { // 说明该学生之前没有操作过置顶、不看他
            studentCardArr.push({
              user_id: selectItem['user_id'],
              handleStatus: status,
              handleTime: currentTime
            })
            sessionStorage.setItem('studentCardX', JSON.stringify(studentCardArr));
          } else { // 该学生被操作过置顶、不看他，直接从sessionStorage中移除掉
            studentCardArr.splice(findIndex, 1);
            sessionStorage.setItem('studentCardX', JSON.stringify(studentCardArr));
          }
        } else {
          let studentCardX = [];
          let firstStudent = {
            user_id: selectItem['user_id'],
            handleStatus: status,
            handleTime: currentTime
          }
          studentCardX.push(firstStudent);
          sessionStorage.setItem('studentCardX', JSON.stringify(studentCardX));
        }
      },
      // 暂时不看ta
      notFollowTaOrFollow (selectItem, selectIndex) {
        this.$emit('notFollowTaOrFollow', selectItem, selectIndex);
      },
      filterMessageList(messageList, user_id) {
        return messageList.filter(item => {
          return item.user_id == user_id && item.disposeStatus === false && this.alarmLimitList.indexOf(item.event) > -1;
        })
      },
      // 显示报警，将当前的学生的报警数量设置为0
      showAlarm (user_id) {
        this.$emit('setMessageDisposeStatus', user_id);
      },
      // 显示排序的
      sortStudentData(data) {
        let newData = data.slice();
        newData.slice().sort((a,b) => b.offLineStatus - a.offLineStatus);
        let onlineStudent = [];
        let offLineStudent = [];
        newData.map(item => {
          if (!item['offLineStatus']) { // 在线
            let lastUserName = '';
            if (item['real_name']) {
              lastUserName = item['real_name'];
            } else {
              lastUserName = item.data[0].real_sname || item.data[0].nick
            }
            item['lastUserName'] = lastUserName;
            onlineStudent.push(item);
          } else {
            let lastUserName = '';
            if (item['real_name']) {
              lastUserName = item['real_name'];
            } else {
              lastUserName = item.data[0].real_sname || item.data[0].nick
            }
            item['lastUserName'] = lastUserName;
            offLineStudent.push(item);
          }
        })
        if (!!sessionStorage.getItem('studentCardX')) {
          let studentCardXArr = JSON.parse(sessionStorage.getItem('studentCardX'));
          if (studentCardXArr.length == 0) {
            onlineStudent.map((item, index) => {
              let newItem = item;
              newItem['handleStatus'] = 2;
              this.$set(onlineStudent, index, newItem);
            })
            onlineStudent = onlineStudent.sort(function compareFunction(item1, item2) {
              let studentName1 = item1['real_name'] || item1['nick'] || item1['uname'];
              let studentName2 = item2['real_name'] || item2['nick'] || item2['uname'];
              return studentName1.localeCompare(studentName2);
            });
            offLineStudent = offLineStudent.sort(function compareFunction(item1, item2) {
              let studentName1 = item1['real_name'] || item1['nick'] || item1['uname'];
              let studentName2 = item2['real_name'] || item2['nick'] || item2['uname'];
              return studentName1.localeCompare(studentName2);
            });
            return onlineStudent.concat(offLineStudent);
          } else {
            let topStudentArr = [];
            let normalStudentArr = [];
            let bottomStudentArr = [];
            for (let i=0; i < onlineStudent.length; i++) {
              let dataItem = onlineStudent[i];
              let isExist = false;
              for (let j=0; j < studentCardXArr.length; j++ ) {
                let cardItem = studentCardXArr[j];
                if (dataItem['user_id'] == cardItem['user_id']) {
                  isExist = true;
                  if (cardItem['handleStatus'] == 1) { // 暂时不看他
                    dataItem['handleStatus'] = 1;
                    dataItem['handleTime'] = cardItem['handleTime'];
                    bottomStudentArr.push(dataItem);
                  } else if (cardItem['handleStatus'] == 3) { // 置顶
                    dataItem['handleStatus'] = 3;
                    dataItem['handleTime'] = cardItem['handleTime'];
                    topStudentArr.push(dataItem);
                  }
                  break;
                } else {
                  isExist = false;
                }
              }

              if (!isExist) {
                normalStudentArr.push(dataItem);
              }
            }
            // topStudentArr = topStudentArr.sort((a,b) => a.handleTime - b.handleTime);
            topStudentArr = topStudentArr.sort(function compareFunction(item1, item2) {
              if (item1['real_name'] && item2['real_name']) {
                return item1['real_name'].localeCompare(item2['real_name']);
              }
            });
            normalStudentArr = normalStudentArr.sort(function compareFunction(item1, item2) {
              if (item1['real_name'] && item2['real_name']) {
                return item1['real_name'].localeCompare(item2['real_name']);
              }
            });
            bottomStudentArr = bottomStudentArr.sort(function compareFunction(item1, item2) {
              if (item1['real_name'] && item2['real_name']) {
                return item1['real_name'].localeCompare(item2['real_name']);
              }
            });
            let lastArr = topStudentArr.concat(normalStudentArr).concat(bottomStudentArr).concat(offLineStudent);
            return lastArr
          }
        } else { // 说明之前没操作过置顶、不看他
          onlineStudent.map((item, index) => {
            let newItem = item;
            newItem['handleStatus'] = 2;
            this.$set(onlineStudent, index, newItem);
          })
          onlineStudent = onlineStudent.sort(function compareFunction(item1, item2) {
            if (item1['real_name'] && item2['real_name']) {
              return item1['real_name'].localeCompare(item2['real_name']);
            }
          });
          offLineStudent = offLineStudent.sort(function compareFunction(item1, item2) {
            if (item1['real_name'] && item2['real_name']) {
              return item1['real_name'].localeCompare(item2['real_name']);
            }
          });
          let lastArr = onlineStudent.concat(offLineStudent);
          return lastArr
        }
      },
      //设置颜色
      getColor(id){
        return setColor(id)
      },
      // 移除学生
      closeCard (params) {
        this.$emit('closeCard', params);
      },
      classObject (offLineStatus, handleStatus, type) {
        if (type == 'left') { // 左侧列表
          if (offLineStatus) { // 离线
            return 'student-module offLine';
          } else {
            if (handleStatus == 1) { // 不关注他
              return 'student-module not-attention';
            } else { // 正常
              return 'student-module';
            }
          }
        } else { // list
          if (offLineStatus) { // 离线
            return 'single-student offLine';
          } else {
            if (handleStatus == 1) { // 不关注他
              return 'single-student not-attention';
            } else { // 正常
              return 'single-student';
            }
          }
        }
      },
      getAlarmNum (val) {
        const vm = this
        let count = 0;
        let notHandleMessageList = vm.messageList.filter(item => item.disposeStatus === false)
        let newMessageList = this.uniqeByKeys(notHandleMessageList, ['c_time', 'user_id'])
        newMessageList.forEach(item => {
          if (val.user_id == item.user_id) {
            count++;
          }
        })
        // console.log('user_id='+val.user_id, 'countcountcountcountcountcountcountcountcount='+count)
        return count;
      },
      uniqeByKeys(array, keys) {
        var allArr = []
        for (var i = 0; i < array.length; i++) {
          var flag = true
          for (var j = 0; j < allArr.length; j++) {

            if (array[i].user_id === allArr[j].user_id && array[i].event === allArr[j].event && Math.abs(array[i].c_time - allArr[j].c_time) <= 1000 && !eventCheck) {
              flag = false
            }
          }
          let eventCheck = this.alarmLimitList.some((item)=>{
            return item == array[i].event
          })
          if (flag && eventCheck) {
            allArr.push(array[i])
          }
        }
        return allArr
      },
      queryAuthUserCount() {
        let subjectId = sessionStorage.getItem('subject_id')
        getAuthUserCount({subject_id: subjectId}).then(res => {
          if (res.code == 200) {
            this.authUserCount = res.data.count;
          }
        })
      }
    },
    filters: {
      parseTime(time) {
        if (arguments.length === 0) {
          return null
        }
        const format = '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
          date = time
        } else {
          if (('' + time).length === 10) time = parseInt(time) * 1000
          date = new Date(time)
        }
        const formatObj = {
          y: date.getFullYear(),
          m: date.getMonth() + 1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
          let value = formatObj[key]
          if (key === 'a') return [this.$t('studentList.list.263629-20'), this.$t('studentList.list.263629-21'), this.$t('studentList.list.263629-22'), this.$t('studentList.list.263629-23'), this.$t('studentList.list.263629-24'), this.$t('studentList.list.263629-25'), this.$t('studentList.list.263629-26')][value - 1]
          if (result.length > 0 && value < 10) {
            value = '0' + value
          }
          return value || 0
        })
        return time_str
      },
      parseUserSpentTime(msd) {
        var time = parseFloat(msd) / 1000
        if (time !== null && time !== '') {
          if (time > 60 && time < 60 * 60) {
            time = parseInt(time / 60.0) + this.$t('studentList.list.263629-27') + parseInt((parseFloat(time / 60.0) -
              parseInt(time / 60.0)) * 60) + this.$t('studentList.list.263629-28')
          } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
            time = parseInt(time / 3600.0) + this.$t('studentList.list.263629-29') + parseInt((parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) * 60) + this.$t('studentList.list.263629-27') +
              parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
                parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + this.$t('studentList.list.263629-28')
          } else {
            if (isNaN(time)) {
              return this.$t('studentList.list.263629-30')
            } else {
              if (time < 0) {
                time = 0
              }
              time = parseInt(time) + this.$t('studentList.list.263629-28')
            }
          }
        }
        return time
      },
      // 卡片事件
      getEventName(val, videoType) {
        let eventName = ''
        let typeStr = ''

        if (videoType == 'IMPORT') {
          typeStr = this.$t('studentList.list.263629-31');
        } else if (videoType == 'KNOWLEDGE') {
          typeStr = this.$t('studentList.list.263629-32');
        } else if (videoType == 'QTID') {
          typeStr = this.$t('studentList.list.263629-33');
        } else if (videoType == 'ANALYZE') {
          typeStr = this.$t('studentList.list.263629-34');
        } else if (videoType == 'ERRORCAUSE') {
          typeStr = this.$t('studentList.list.263629-35');
        } else if (videoType == 'SKILL') {
          typeStr = this.$t('studentList.list.263629-36');
        } else if (videoType == 'QUESTION') {
          typeStr = this.$t('studentList.list.263629-37');
        } else if (videoType == 'TAIL') {
          typeStr = this.$t('studentList.list.263629-38');
        }

        switch (val.event) {
          case 'LOGIN':
            eventName = this.$t('studentList.list.263629-39')
            break
          case 'RELOGIN':
            eventName = this.$t('studentList.list.263629-40')
            break
          case 'MODULE_START':
            eventName = this.$t('studentList.list.263629-41')
            break
          case 'GET_QUESTION':
            if (val.hasOwnProperty('question_round')) {
              if (val.question_round == 1) {
                eventName = this.$t('studentList.list.263629-42')
              } else if (val.question_round == 2) {
                eventName = this.$t('studentList.list.263629-43')
              }
            } else {
              eventName = this.$t('studentList.list.263629-44')
            }
            break
          case 'GET_QUESTION':
            eventName = this.$t('studentList.list.263629-44')
            break
          case 'SUBMIT_ANSWER':
            eventName = val.flow_id == 1000 ? '考试结束' : this.$t('studentList.list.263629-45')
            break
          case 'GET_ANALYSIS':
            if (val.hasOwnProperty('question_round')) {
              if (val.question_round == 1) {
                eventName = this.$t('studentList.list.263629-46')
              } else if (val.question_round == 2) {
                eventName = this.$t('studentList.list.263629-47')
              }
            } else {
              eventName = this.$t('studentList.list.263629-48')
            }
            break
          case 'GET_QLIST':
            eventName = this.$t('studentList.list.263629-49')
            break
          case 'GET_REPORT':
            eventName = this.$t('studentList.list.263629-50')
            break
          case 'VIDEO_PLAY':
          case 'EAMPLE_PROBLEM_TRIAL_DONE':
            eventName = this.$t('studentList.list.263629-51') + typeStr + this.$t('studentList.list.263629-52')
            break
          case 'VIDEO_CLOSE':
            eventName = this.$t('studentList.list.263629-12') + typeStr + this.$t('studentList.list.263629-52')
            break
          case 'VIDEO_END':
            eventName = this.$t('studentList.list.263629-53')
            break
          case 'VIDEO_PAUSE':
            eventName = this.$t('studentList.list.263629-54') + typeStr + this.$t('studentList.list.263629-52')
            break
          case 'VIDEO_DRAG':
            eventName = this.$t('studentList.list.263629-55') + typeStr + this.$t('studentList.list.263629-52')
            break
          case 'VIDEO_BACK':
            eventName = this.$t('studentList.list.263629-56') + typeStr + this.$t('studentList.list.263629-52')
            break
          case 'VIDEO_SKIP':
            eventName = this.$t('studentList.list.263629-57') + typeStr + this.$t('studentList.list.263629-52')
            break
          case 'EAMPLE_PROBLEM_TRIAL_START':
          case 'EAMPLE_PROBLEM_TRIAL_CORRECTION':
            eventName = '例题试做';
            break
          case 'VIDEO_END_DAZE':
            eventName = this.$t('studentList.list.263629-58')
            break
          case 'VIDEO_PAUSE_DAZE':
            eventName = this.$t('studentList.list.263629-59')
            break
          case 'VIDEO_UNPLAYED_SKIP':
            eventName = this.$t('studentList.list.263629-60')
            break
          case 'NO_ACTION':
            eventName = this.$t('studentList.list.263629-61')
            break
          case 'WARN_VIDEO_UNPLAYED_SKIP':
            eventName = this.$t('studentList.list.263629-62')
            break
          case 'WARN_VIDEO_PLAYED_SKIP':
            eventName = this.$t('studentList.list.263629-63')
            break
          case 'WARN_VIDEO_PAUSE_DAZE':
            eventName = this.$t('studentList.list.263629-59')
            break
          case 'WARN_VIDEO_END_DAZE':
            eventName = this.$t('studentList.list.263629-58')
            break
          case 'WARN_NO_ACTION':
            eventName = this.$t('studentList.list.263629-64')
            break
          case 'ANSWER_HESITATE':
            eventName = this.$t('studentList.list.263629-65')
            break
          case 'WARN_ANSWER_HESITATE':
            eventName = this.$t('studentList.list.263629-65')
            break
          // case 'WARN_MODULE_END':
          //   eventName = '模块完成报警'
          //   break
          case 'WARN_WRONG_ANSWER':
            eventName = this.$t('studentList.list.263629-66')
            break
          case 'MODULE_END':
            eventName = this.$t('studentList.list.263629-67')
            break
          case 'TAG_CODE_END':
            eventName = this.$t('studentList.list.263629-68')
            break
          case 'WARN_ANSWE_TOO_SLOW':
            eventName = this.$t('studentList.list.263629-69')
            break
          case 'WARN_ANSWE_TOO_FAST':
            eventName = this.$t('studentList.list.263629-70')
            break
          default:
            eventName = this.$t('studentList.list.263629-30')
        }
        return eventName
      },
      formatTime (s) {
        let result = '';
        if (s == 0) {
          result = this.$t('studentList.list.263629-71');
        } else {
          var day = Math.floor( s/ (24*3600) ); // Math.floor()向下取整
          var hour = Math.floor( (s - day*24*3600) / 3600);
          var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 );
          var second = s - day*24*3600 - hour*3600 - minute*60;

          if (day > 0) {
            result = this.$t('studentList.list.263629-72', [day])
          }

          if (hour > 0) {
            result += this.$t('studentList.list.263629-73', [hour])
          }

          if (minute > 0) {
            result += this.$t('studentList.list.263629-74', [minute])
          }

          if (second > 0) {
            result += this.$t('studentList.list.263629-75', [second])
          }
        }
        // return day + "天"  + hour + "时" + minute + "分" + second + this.$t('studentList.list.263629-28');
        return result;
      }
    },
    // 根据videoType显示视频类型
    judgeVideoType (type) {
      let typeStr = '';
      switch (type) {
        case 'IMPORT':
          typeStr = this.$t('studentList.list.263629-31');
          break;
        case 'KNOWLEDGE':
          typeStr = this.$t('studentList.list.263629-32');
          break;
        case 'QTID':
          typeStr = this.$t('studentList.list.263629-33');
          break;
        case 'ANALYZE':
          typeStr = this.$t('studentList.list.263629-34');
          break;
        case 'ERRORCAUSE':
          typeStr = this.$t('studentList.list.263629-35');
          break;
        case 'SKILL':
          typeStr = this.$t('studentList.list.263629-36');
          break;
        case 'QUESTION':
          typeStr = this.$t('studentList.list.263629-37');
          break;
        default:
          typeStr = '';
          break;
      }
      return typeStr;
    },
  }
</script>

<style scoped lang="scss">
  .student-count {
    margin-bottom: 17px;
    font-size: 18px;
    font-weight: 600;
    color: rgba(68,75,101,1);
  }
  .student-ul {
    .single-student {
      position: relative;
      box-sizing: content-box;
      height: 130px;
      margin-bottom: 11px;
      overflow: hidden;
      clear: both;
      background: rgba(255,255,255,1);
      border-radius: 8px;
      box-shadow: 0 6px 12px 0 rgba(68,75,101,.06);
      .student-item {
        display: flex;
        .left-image {
          float: left;
          width: 60px;
          height: 180px;
          padding: 12px 12px 0 24px;
          .photo {
            position: relative;
            display: flex;
            align-items: center;
            width: 58px;
            height: 58px;
            text-align: center;
            background: #69dad8;
            border-radius: 100px;
            .name {
              width: 58px;
              height: 15px;
              font-size: 20px;
              font-weight: 400;
              line-height: 15px;
              color: rgba(255,255,255,1);
            }
          }
        }
        .right-detail {
          position: relative;
          float: left;
          width: 1204px;
          padding: 13px 0 0 0;
          .user-info {
            font-size: 14px;
            color: #868a9b;
            .user-name {
              display: inline-block;
              height: 28px;
              margin-right: 19px;
              font-size: 16px;
              font-weight: 600;
              line-height: 28px;
              color: rgba(68,75,101,1);
            }
          }
          .detail-info-ul {
            display: flex;
            overflow: hidden;
            li {
              float: left;
              width: 25%;
              color: #858a9b;
              .emphasize {
                height: 25px;
                font-size: 16px;
                font-weight: 600;
                line-height: 25px;
                color: rgba(68,75,101,1);
              }
              .num {
                height: 20px;
                font-size: 20px;
                font-weight: 500;
                line-height: 20px;
                color: #2980ff;
                &.red-num {
                  color: #ff4757;
                }
              }
              .today-data {
                width: 140px;
                // text-align: center;
              }
              .first-line {
                margin-bottom: 7px;
                .module_sname_label {
                  color: #444b65;
                }
                .small-num {
                  font-size: 12px;
                }
              }
              .second-line {
                margin-bottom: 7px;
                font-size: 14px;
                .red-num {
                  color: #ff4757;
                }
              }
              .third-line {
                // margin-bottom: 12px;
                font-size: 14px;
                display: flex;
                .knowledge-label {
                  width: 60px;
                }
                .current-knowdlege-name {
                  max-height: 40px;
                  max-width: 160px;
                  // text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  // display: -webkit-box;
                  // -webkit-line-clamp: 2;
                  // line-clamp: 2;
                  // -webkit-box-orient: vertical;
                }
              }
              &.count {
                // width: 180px;
                .rate-num {
                  font-size: 14px;
                }
              }
              &.is-jieru {
                width: 80px;
              }
              &.option {
                float: right;
                width: 50px;
                margin-right: 23px;
                text-align: right;
              }
            }
          }
          .now-jieru {
            position: absolute;
            right: 0;
            bottom: -21px;
            width: 110px;
            height: 73px;
          }
        }
      }
      &:hover {
        cursor: pointer;
        border: 1px solid rgba(41,128,255,1);
      }
      .has-zgt {
        position: absolute;
        top: 0;
        right: 0;
      }
      &.not-attention {
        background: #f3f6fd;
      }
      &.offLine {
        background: #f5f5f5;
      }
    }
  }

  .no-people {
    padding-bottom: 204px;
    .text {
      font-size: 16px;
      line-height: 24px;
      color: #444b65;
      text-align: center;
      opacity: .8;
    }
  }

  .card-list {
    .card-ul {
      overflow: hidden;
      .card-item {
        box-sizing: border-box;
        float: left;
        width: 410px;
        height: 302px;
        margin: 0 20px 29px 0;
        cursor: pointer;
        background: rgba(255,255,255,1);
        border: 1px solid rgba(225,237,255,1);
        border-radius: 8px;
        box-shadow: 0 6px 12px 0 rgba(68,75,101,.06);
        .user-info {
          display: flex;
          justify-content: start;
          margin: 25px 0 0 20px;
          .left-image {
            .photo-image {
              display: flex;
              align-items: center;
              width: 36px;
              height: 36px;
              text-align: center;
              background: #90df89;
              border-radius: 100px;
              .name {
                width: 36px;
                height: 15px;
                font-size: 12px;
                font-weight: 500;
                color: #fff;
              }
            }
          }
          .user-course {
            margin-left: 13px;
            .user-name {
              height: 28px;
              margin-top: 3px;
              font-size: 20px;
              font-weight: 600;
              line-height: 28px;
              color: #444b65;
            }
            .course-detail {
              width: 300px;
              margin-top: 4px;
              overflow: hidden;
              font-size: 12px;
              line-height: 19px;
              color: #858a9b;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .handle-wrap {
          display: flex;
          margin-top: 30px;
          margin-left: 17px;
          .handle-item {
            .current {
              font-size: 18px;
              color: #444b65;
            }
            &.first {
              width: 151px;
            }
            &.second {
              width: 77px;
              text-align: center;
              border-right: 1px dotted #e4eff6;
              .rate {
                font-size: 18px;
                color: #ff4757;
              }
            }
            &.third {
              margin-left: 14px;
              text-align: center;
              .rate {
                font-size: 18px;
                color: #207cff;
              }
            }
            .bottom-tips {
              font-size: 12px;
              color: #858a9b;
            }
          }
        }
        .current-module {
          display: flex;
          align-items: center;
          height: 42px;
          margin: 29px 19px 37px 19px;
          background: #eff6ff;
          background: rgba(239, 246, 255, .68);
          border: 1px solid #edf5ff;
          border-radius: 4px;
          .module-name {
            font-size: 14px;
            font-weight: 600;
            color: #444b65;
          }
          .knowledge-text {
            font-size: 14px;
            line-height: 20px;
            color: #858a9b;
          }
        }
        .history-ul {
          padding: 0 18px;
        }
        &:hover {
          border: 1px solid #207cff;
        }
      }
    }
  }
  .left-list {
    // min-height: 1127px;
    // height: 800px;
    .module-header-title {
      margin: 14px 0 17px 18px;
    }
    .sub {
      margin: 11px 0 0 20px;
      font-size: 14px;
    }
    .student-list {
      padding-bottom: 80px;
      // margin-top: 8px;
      margin-left: 11px;
      overflow-y: auto;
      .single-item {
        position: relative;
        box-sizing: border-box;
        height: 61px;
        .student-module {
          box-sizing: border-box;
          height: 61px;
          padding: 11px 10px 10px 6px;
          overflow: hidden;
          border-bottom: 1px solid #d3d8e8;
          display: flex;
          .left-side {
            float: left;
            width: 32px;
            height: 45px;
            margin-top: 3px;
            // padding-left: 9px;
            .photo-content {
              position: relative;
              display: flex;
              align-items: center;
              width: 32px;
              height: 32px;
              text-align: center;
              background: #69dad8;
              border-radius: 100px;
              .name {
                width: 32px;
                height: 12px;
                font-size: 12px;
                font-weight: 400;
                line-height: 12px;
                color: #fff;
              }
            }
            .alarm-module {
              top: -7px;
              right: -3px;
            }
          }
          .right-side {
            position: relative;
            float: left;
            margin-left: 12px;
            .user-name-x {
              position: relative;
              margin-bottom: 4px;
              font-size: 14px;
              font-weight: 500;
              color: rgba(68,75,101,1);
              .left-user-name {
                position: relative;
                display: flex;
                align-items: center;
                .student-name {
                  width: 60px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                }
              }
              .wait-correct {
                position: absolute;
                right: -4px;
                top: -11px;
              }
            }
            .module {
              width: 200px;
              margin-left: -7px;
              overflow: hidden;
              font-size: 12px;
              font-weight: 400;
              color: #696f84;
              text-overflow: ellipsis;
              white-space: nowrap;
              &.empty {
                margin-left: 3px;
              }
            }
            .current-option {
              width: 133px;
              // height: 20px;
              margin-left: 8px;
              // margin-bottom: 8px;
              font-size: 12px;
              font-weight: 400;
              // line-height: 20px;
              color: #2980ff;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
            .jieru {
              position: absolute;
              right: -20px;
              bottom: -7px;
            }
            .answer-question-detail {
              display: flex;
              li {
                .num-rate {
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(68,75,101,1);
                  &.red {
                    color: #ff4757;
                  }
                }
                .rate-text {
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(68,75,101,.4);
                }
                &:first-child {
                  margin-right: 41px;
                }
              }
            }

          }
          .handle {
            position: absolute;
            top: 12px;
            right: 8px;
            width: 40px;
            height: 40px;
          }
          &.not-attention {
            background: #f3f6fd;
          }
          &.offLine {
            background: #f5f5f5;
          }
        }
        &:last-child {
          border-bottom: none;
        }
        // .wait-correct {
        //   position: absolute;
        //   top: 0;
        //   right: 0;
        // }
        &.active {
          background: #F3F6FD;
        }
        &.not-follow {
          background: #f5f8ff;
          .student-module {
            .right-side {
              .user-name-x {
                color: #a7b2d2;
              }
              .module {
                color: #a7b2d2;
              }
              .current-option {
                color: #a7b2d2;
              }
            }
          }
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/views/studentList/list.vue